import { alertError } from './../alert/actions';
import { apiUrl } from './../../index';
import { CardEvent, EventActionTypes } from 'src/store/events/types';
import { action } from 'typesafe-actions';
import { BusActionTypes } from './types';
import axios, { AxiosResponse } from 'axios';
import { alertSuccess } from '../alert/actions';

export const hideBus = (busId: number) => {
  const fetchRequest = () => action(BusActionTypes.REQUEST);
  const fetchError = (error: Error) => action(BusActionTypes.ERROR, error);

  interface Response {
    cardevent: CardEvent;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .put(`${apiUrl}/bus/hide/${busId}`)
      .then((res: AxiosResponse<Response>) => {
        dispatch(action(EventActionTypes.FETCH_SINGLE_SUCCESS, res.data.cardevent));
        dispatch(alertSuccess('Bus versteckt'));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const showBus = (busId: number) => {
  const fetchRequest = () => action(BusActionTypes.REQUEST);
  const fetchError = (error: Error) => action(BusActionTypes.ERROR, error);

  interface Response {
    cardevent: CardEvent;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .put(`${apiUrl}/bus/unhide/${busId}`)
      .then((res: AxiosResponse<Response>) => {
        dispatch(action(EventActionTypes.FETCH_SINGLE_SUCCESS, res.data.cardevent));
        dispatch(alertSuccess('Bus eingeblendet'));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/bus/action.ts